import { render, staticRenderFns } from "./ModalTemplateBootstrap.vue?vue&type=template&id=5177e9ce&"
import script from "./ModalTemplateBootstrap.vue?vue&type=script&lang=js&"
export * from "./ModalTemplateBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports